import React, { useCallback, useMemo, useRef } from 'react';
import { SceneAnchorKey, SceneAnchorMap, SceneContext } from './sceneRegistry';

export const SceneProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const anchors = useRef<SceneAnchorMap>(new Map());

  const registerAnchor = useCallback((key: SceneAnchorKey, el: HTMLElement | null) => {
    if (el) {
      anchors.current.set(key, el);
    } else {
      anchors.current.delete(key);
    }
  }, []);

  const value = useMemo(() => ({ anchors, registerAnchor }), [registerAnchor]);

  return <SceneContext.Provider value={value}>{children}</SceneContext.Provider>;
};
